import script from "./preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./preview.vue?vue&type=script&setup=true&lang=ts"

import "./preview.vue?vue&type=style&index=0&id=10dae14e&lang=css"

const __exports__ = script;

export default __exports__